import script from "./AgentToneSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentToneSelector.vue?vue&type=script&setup=true&lang=js"

import "./AgentToneSelector.vue?vue&type=style&index=0&id=32e27fd1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e27fd1"]])

export default __exports__